import { mapErknmPlanStatusByStatusTitle } from 'APIPackage/PlanListModule/constants/mapErknmPlanStatusByStatusTitle';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { ErknmPlanStatusTitlesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusTitlesEnum';

export const getPlanErknmStatusByStatusTitle = (
  statusTitle: ErknmPlanStatusTitlesEnum | null | undefined,
): ErknmPlanStatusesEnum | undefined => {
  if (statusTitle) {
    return mapErknmPlanStatusByStatusTitle[statusTitle];
  }

  return undefined;
};
